import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import StatusChip from '../../../MUI_custom_component/chips/StatusChip';
import { REWARD_TABS } from '../utils';

const GiftMobileCards = ({filteredData,selectedStatus, handleShowDetails, GiftStatusEnum, selectedTab }) => {
  return (
    <Box>
          {filteredData.length > 0 ? (
            filteredData.map((gift, index) => {
              const statusData = Object.values(GiftStatusEnum).find(
                (s) => s.status === gift.status,
              );
              return (
                <Card
                  key={index}
                  sx={{
                    cursor: 'pointer',
                    mb: 2,
                    borderRadius: '12px',
                    boxShadow:
                      '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                  }}
                  onClick={() => handleShowDetails(gift.id)}
                >
                  <CardContent
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Box sx={{ pr: 1 }}>
                      <Typography
                        variant='body1'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Beneficiary: {gift.beneficiary_name}
                      </Typography>
                      
                      <Typography
                        variant='body2'
                        sx={{}}
                      >
                        Gift Name: {gift.gift_product_name}
                      </Typography>
                      <Typography variant='body2'>
                        Phone: {gift.beneficiary_phone}
                      </Typography>
                      <Typography variant='body2'>
                        Role: {gift.beneficiary_role}
                      </Typography>
                      {(selectedTab === REWARD_TABS['INFLUENCER'] || selectedTab === REWARD_TABS['NETWORK_INFLUENCER']) && (
                        <Typography
                          variant='body1'
                        >
                          Status: <StatusChip type='outlined' label={gift?.verification_status} status={gift?.verification_status}  sx={{ px:0 }}/>
                        </Typography>
                      )}
                      {selectedStatus !== GiftStatusEnum['ANNOUNCED'].status && (
                        <Typography variant='body2'>
                          Announced Date: {gift.announced_date}
                        </Typography>
                      )}
                    </Box>
                    
                    <Box>
                      <Chip
                        label={statusData?.label}
                        sx={{
                          backgroundColor: statusData?.color,
                          color: 'white',
                          fontWeight: 'bold',
                          my: 1,
                        }}
                      />
                      <Typography variant='body2'>
                        {gift.status_change_date}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              );
            })
          ) : (
            <Typography align='center'>No data available</Typography>
          )}
        </Box>
  )
}

export default GiftMobileCards